var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscoverIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0448 7.60898L12.3145 11.4744C11.8923 11.6614 11.5537 11.9894 11.3607 12.3984L7.37056 20.8559C6.91028 21.8314 7.94758 22.8369 8.95524 22.391L17.6855 18.5256C18.1077 18.3386 18.4463 18.0106 18.6393 17.6016L22.6294 9.14414C23.0897 8.16797 22.0524 7.16309 21.0448 7.60898ZM16.3657 16.323C15.6115 17.0537 14.3885 17.0537 13.6343 16.323C12.88 15.5924 12.88 14.4076 13.6343 13.677C14.3885 12.9463 15.6115 12.9463 16.3657 13.677C17.12 14.4076 17.12 15.5924 16.3657 16.323ZM15 0.46875C6.71552 0.46875 0 6.97441 0 15C0 23.0256 6.71552 29.5312 15 29.5312C23.2845 29.5312 30 23.0256 30 15C30 6.97441 23.2845 0.46875 15 0.46875ZM15 26.7188C8.32984 26.7188 2.90323 21.4617 2.90323 15C2.90323 8.53828 8.32984 3.28125 15 3.28125C21.6702 3.28125 27.0968 8.53828 27.0968 15C27.0968 21.4617 21.6702 26.7188 15 26.7188Z",
    fill: "#C6C6C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverIcon);
export default __webpack_public_path__ + "static/media/discover-icon.6af835ed6c0348a5d54f723847974aaa.svg";
export { ForwardRef as ReactComponent };